import * as React from 'react';
import LabcorpInvitaeLogoDark from '../../../assets/logos/LabcorpInvitaeLogoDark.esm.js';
import classNames from 'classnames';
import styles from './CompactHeader.module.esm.js';

var CompactHeader = function (_a) {
    var _b;
    var className = _a.className, _c = _a.fixed, fixed = _c === void 0 ? true : _c, _d = _a.href, href = _d === void 0 ? '/' : _d;
    return (React.createElement("header", { className: classNames((_b = {}, _b[styles.fixedMenu] = fixed, _b), className), "data-testid": "compact-header" },
        React.createElement("nav", { className: styles.wrapper },
            React.createElement("div", { "aria-label": "Main", className: classNames('nv-container', styles.container), role: "navigation" },
                React.createElement("a", { "aria-label": "Invitae's Logo", className: styles.link, href: href, role: "menuitem", tabIndex: 0 },
                    React.createElement(LabcorpInvitaeLogoDark, { height: 36, width: 300 }))))));
};

export { CompactHeader as default };
//# sourceMappingURL=CompactHeader.esm.js.map
